import Img1 from '../../assets/bode.png';
import Img2 from '../../assets/circus.png';
import Img4 from '../../assets/pinche.png';
import Img5 from '../../assets/taquisimo.png';
import Img6 from '../../assets/leicilogo.png';
import Img7 from '../../assets/sanblasLogo.png';

const data = [
    {
      id: 1,
      image: Img1,
      title: "La Bodeguita Xela",
      subtitle:"Social Media Post"
    },
    {
      id: 2,
      image: Img2,
      title: "CircusBar Xela",
      subtitle: "Branding"
    },
    {
      id: 4,
      image: Img4,
      title: "El Pinche Xela",
      subtitle: "Social Media Post"
    },
    {
      id: 5,
      image: Img5,
      title: "Taquisimo",
      subtitle: "Branding"
    },
    {
      id: 6,
      image: Img6,
      title: "Leici",
      subtitle: "Branding"
    },
    {
      id: 7,
      image: Img7,
      title: "SanBlas",
      subtitle: "Branding"
    },
  ];

  export default data;